import React, { JSX } from 'react';
import './AddressComponent.css';
import { BlechconAddress } from '../blechcon';
import { localized } from '../config/localization';

type Props = {
  readonly address: BlechconAddress | undefined;
  readonly title: string;
  readonly selfPickup?: boolean;
};

export function AddressComponent({ address, title, selfPickup }: Props): JSX.Element {
  if (!address) {
    return <></>;
  }
  return (
    <div className="address-component">
      <div className="address-component__title">{title}</div>
      <div>{address.addressLine}</div>
      <div>
        {address.firstName} {address.lastName}
      </div>
      <div>{address.street}</div>
      <div>{address.city}</div>
      <div>{address.state}</div>
      {selfPickup && <div className="address-component__pickup">{localized.PICKUP_YOURSELF}</div>}
    </div>
  );
}
